(function () {
  //Uncomment to reset for testing:
  // localStorage.removeItem('last_visit');
  // localStorage.removeItem('return_shown');
  // sessionStorage.clear();

  const now = new Date().getTime();
  const VISIT_TIMEOUT = 30 * 60 * 1000; // 1 minute for quick testing

  const lastVisit = localStorage.getItem('last_visit');
  const shownAlready = localStorage.getItem('return_shown');
  const sessionActive = sessionStorage.getItem('session_active');

  // Set the last visit time on first load if not already set
  if (!lastVisit) {
    localStorage.setItem('last_visit', now); // ✅ fixed here
    return; // First visit — do not show anything
  }

  // Only run once per browser session
  if (!sessionActive) {
    sessionStorage.setItem('session_active', 'true');

    // If message was already shown once, don't show again
    if (shownAlready) return;

    const timeSinceLastVisit = now - parseInt(lastVisit, 10);

    // If user is returning after timeout (real return)
    if (timeSinceLastVisit > VISIT_TIMEOUT) {
      onReturnVisit();
      localStorage.setItem('return_shown', 'true');
    }
  }

  // On tab/browser close, update the last visit timestamp
  window.addEventListener('pagehide', function () {
    localStorage.setItem('last_visit', new Date().getTime());
  });

  function onReturnVisit() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Tuf33S']);
  }
})();
